import { useEffect } from 'react';
import { Card, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useAppSelector } from '../hooks/hooks';
import logo from '../assets/LogoNavbar.png';
import { tracking } from '../util/tracking';

export default function NotFound() {
  const user = useAppSelector((state) => state.auth.user);
  const location = useLocation();
  const homeHref = user ? '/dashboard' : '/login';

  useEffect(() => {
    document.title = '404 | SupplyPassport App';
    tracking.log('ERROR', 'page_not_found', {
      path: location.pathname,
      search: location.search,
      hash: location.hash,
      referrer: document.referrer,
    });
  }, [location.hash, location.pathname, location.search]);

  return (
    <div className="bg-light min-vh-100 d-flex align-items-center">
      <Container className="py-5">
        <Card
          className="border-0 bg-primary text-light shadow-sm mx-auto text-center"
          style={{ maxWidth: '560px' }}
        >
          <Card.Body className="p-5">
            <img
              src={logo}
              alt="SupplyPassport Logo"
              height="56"
              className="mb-4"
            />
            <div className="text-light fw-semibold mb-2">404</div>
            <h1 className="h2 fw-bold mb-3 text-light">Page not found</h1>
            <p className="text-light mb-4">
              The page you requested does not exist or may have been moved.
            </p>
            <Link to={homeHref} className="btn btn-light text-primary fw-semibold">
              {user ? 'Back to dashboard' : 'Back to login'}
            </Link>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}
